var map = {
	"./activity1.png": "add5",
	"./activity1_2024.png": "df50",
	"./activity2.png": "428fa",
	"./activity2_2024.png": "1322",
	"./activity3.png": "0a40",
	"./activity3_2024.png": "26cd",
	"./activity4.png": "21d6",
	"./activity4_2024.png": "8cc5",
	"./activity5.png": "c103",
	"./activity6.png": "863d",
	"./activity7.png": "893e",
	"./activity8.png": "385a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aa7b";